package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class WidgetDetailPayload(
    val organization: String,
    val seasonID: String,
    val widgetKey: String
)

@Serializable
data class WidgetDetailResponse(
    val clubAverage: Long = 0,
    val coaches: List<WidgetCoach> = emptyList(),
    val widgetKey: String = ""
)

@Serializable
data class WidgetCoach(
    val coachID: String = "",
    val coachName: String = "",
    val score: Long = 0,
    val sessionCount: Long = 0,

    // Methodology Consistency
    @SerialName("consistent_principles")
    val consistentPrinciples: List<String> = emptyList(),

    // Tactical Complexity
    @SerialName("top_concepts")
    val topConcepts: List<String> = emptyList(),

    // Match Analysis
    @SerialName("root_causes")
    val rootCauses: List<String> = emptyList(),

    val strengths: List<String> = emptyList(),

    val weaknesses: List<String> = emptyList(),

    @SerialName("training_priorities")
    val trainingPriorities: List<TrainingPriorities> = emptyList(),

    // Topic Diversity (future proof)
    @SerialName("topic_breakdown")
    val topicBreakdown: List<TopicBreakdown> = emptyList(),

    // Widgets with sub scores
    @SerialName("sub_scores")
    val subScores: WidgetSubScores? = null,

    @SerialName("topics_covered")
    val topicsCovered: List<TopicsCoveredSingle> = emptyList()
)

@Serializable
data class WidgetSubScores(

    // Cognitive Training
    @SerialName("decision_making")
    val decisionMaking: Long? = null,

    val perception: Long? = null,

    @SerialName("problem_solving")
    val problemSolving: Long? = null,

    val scanning: Long? = null,

    @SerialName("tactical_awareness")
    val tacticalAwareness: Long? = null,

    // Competitive Environment
    val accountability: Long? = null,

    val competition: Long? = null,

    @SerialName("scoring_systems")
    val scoringSystems: Long? = null,

    @SerialName("time_pressure")
    val timePressure: Long? = null,

    @SerialName("winning_conditions")
    val winningConditions: Long? = null,

    // Game Realism
    @SerialName("directional_play")
    val directionalPlay: Long? = null,

    @SerialName("match_pressure")
    val matchPressure: Long? = null,

    val opposition: Long? = null,

    val transitions: Long? = null,

    // Match Analysis
    @SerialName("in_possession")
    val inPossession: Long? = null,

    @SerialName("out_of_possession")
    val outOfPossession: Long? = null,

)

@Serializable
data class TrainingPriorities(
    val area: String = "",
    val percentage: Long = 0
)

@Serializable
data class TopicBreakdown(
    val name: String = "",
    val percentage: Long = 0
)

@Serializable
data class GameRealismCoach(
    val coachID: String,
    val coachName: String,
    val score: Long,
    val sessionCount: Long,

    @SerialName("sub_scores")
    val subScores: GameRealismSubScores
)


@Serializable
data class TopicsCoveredSingle(
    val percentage: Long = 0,
    val topic: String = ""
)